import { render, staticRenderFns } from "./TotalSection.vue?vue&type=template&id=580cb758&scoped=true&"
import script from "./TotalSection.vue?vue&type=script&lang=js&"
export * from "./TotalSection.vue?vue&type=script&lang=js&"
import style0 from "./TotalSection.vue?vue&type=style&index=0&id=580cb758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580cb758",
  null
  
)

export default component.exports